import type {PublicMethodUtils} from '@wix/document-services-types'
import type {PartnersPublicAPI} from '@wix/document-services-public-types'
import {partners} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<PartnersPublicAPI> {
    return {
        methods: {
            partners: {
                isPotentialPartnerAsync: publicMethodUtils.defineGetter(partners.isPotentialPartnerAsync)
            }
        },
        initMethod: partners.initState
    }
}
